<template>
  <button-with-icon
    v-if="currentFavlistInfluencers.includes(influencerId)"
    :title="$t('common.button.remove-from-favlist')"
    :icon="`${$publicPath}img/favorite-remove.png`"
    version="white"
    @click="removeFromFavlist"
  />
</template>

<script>
import ButtonIconRight from '../../components/buttons/ButtonIconRight'

export default {
  components: {
    'button-with-icon': ButtonIconRight
  },
  props: {
    influencerId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      buttonLoader: false
    }
  },
  computed: {
    currentFavlistInfluencers () {
      const list = this.$store.state.favlist.items
      return list.map((item) => item.influencer.id)
    }
  },
  methods: {
    removeFromFavlist () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('favlist/delete', this.influencerId)
        .then(() => {
          this.buttonLoader = false
          this.$flash.success(this.$t('view-Favlist.message.remove.success'))
        })
        .catch((e) => {
          this.$flash.error(this.$t('view-Favlist.message.remove.error'))
          this.buttonLoader = false
        })
    }
  }
}
</script>
